<div class="slider-list" [ngStyle]="{'height': '1px', 'visibility': 'hidden'}" #slidesContainer>
    <ng-container *ngTemplateOutlet="slides"></ng-container>
</div>
